import { Types } from "../actionTypes";
import { combineReducers } from "@reduxjs/toolkit";

export const initialState = {
  startTab: null,
};

function travel(state = initialState, action) {
  switch (action.type) {
    case Types.ADD_TRAVEL_START_TAB:
      return {
        ...state,
        startTab: action.payload,
      };

    case Types.RESET_TRAVEL_START_TAB:
      return {
        ...state,
        startTab: null,
      };

    default:
      return state;
  }
}

export const getTravelStartTab = (state) => state.travel.startTab;

export default combineReducers({
  travel,
});
